import endChat from './endChat';
import getChatBySessionId from '../selectors/getChatBySessionId';
import InstantMessagePayload from 'owa-service/lib/contract/InstantMessagePayload';

export default function removeUnacceptedChat(notification: InstantMessagePayload) {
    const chat = getChatBySessionId(notification.ChatSessionId);
    if (chat && chat.messages.length == 0) {
        endChat(chat);
    }
}
